import { render, staticRenderFns } from "./Corporation.vue?vue&type=template&id=f0d06a8e&scoped=true&"
import script from "./Corporation.vue?vue&type=script&lang=js&"
export * from "./Corporation.vue?vue&type=script&lang=js&"
import style0 from "./Corporation.vue?vue&type=style&index=0&id=f0d06a8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d06a8e",
  null
  
)

export default component.exports